{
  "overlay": {
    "viewArchive": {
      "title": "浏览往期电子报",
      "description": "点击这里查看往期电子报"
    },
    "startReading": {
      "title": "开始阅读",
      "description": "点击这里打开最新电子报"
    }
  },
  "tutorials": [
    {
      "title": "展开新体验",
      "body": "用户体验现已提升，您可以快速访问任何电子报页面、轻松选看存档和开启阅读模式。前往教程了解更多。"
    },
    {
      "title": "新阅读模式",
      "body": "点击电子报文章便可开启阅读模式，瞬间享受更自然舒适的阅读体验。"
    },
    {
      "title": "阅读过去的电子报",
      "body": "在这里选看过去的电子报"
    },
    {
      "title": "快速访问所有页面",
      "body": "快速预览并跳转至其他栏目或页面"
    },
    {
      "title": "浏览更多电子报",
      "body": "错过近期的报章？随时选看过去的电子报，轻松跟上重点动态。"
    },
    {
      "title": "图片下载",
      "body": "将页面作为图像保存到您的设备"
    },
    {
      "title": "文章分享",
      "body": "点击分享图标发送链接"
    },
    {
      "title": "在视图之间切换",
      "body": "使用切换按钮在文章和打印视图之间切换"
    }
  ]
}
